import cn from 'classnames';
import { useSelector } from 'react-redux';
import { getCountDownAd } from 'components/CountdownAd/selector';
import { getCartItemQuantity } from 'components/Basket/selector';
import { getNumberOfFavourites } from 'components/Favourites/selector';
import { CountdownAd } from 'components/CountdownAd/themes/BGH-RD3/countdownAd';
import { ContactInfo } from 'components/ContactInfo/themes/BGH/ContactInfo';
import { StoresInfo } from 'components/StoreInfo/themes/BGH-RD3/StoresInfo';
import styles from './styles.scss';
import { SiteMode } from './siteMode';
import { selectBlackFridayStatus, selectCustomerPage, selectHelpCenter } from './selector';
import TopBarLink from './topBarLink';

export const TopBar = () => {
  const countDownAd = useSelector(getCountDownAd);
  const quantity = useSelector(getCartItemQuantity);
  const numberOfFavourites = useSelector(getNumberOfFavourites);
  const blackFridayIsActive = useSelector(selectBlackFridayStatus);
  const customerPageInfo = useSelector(selectCustomerPage);
  const helpCenter = useSelector(selectHelpCenter);

  const hasItemsInBasket = quantity > 0;
  const hasFavourites = numberOfFavourites > 0;

  return (
    <>
      <div
        className={cn(styles.contactRow, styles.topBar, {
          [styles.withBasketNoFavourites]: hasItemsInBasket && !hasFavourites,
          [styles.withFavouritesNoBasket]: !hasItemsInBasket && hasFavourites,
          [styles.noBasketNoFavourites]: !hasItemsInBasket && !hasFavourites,
          [styles.blackFriday]: blackFridayIsActive
        })}
      >
        <ContactInfo />
        <StoresInfo className={styles.stores} />
        <TopBarLink navBlock={customerPageInfo} type="CustomerPage" />
        <TopBarLink navBlock={helpCenter} type="HelpCenter" />
        <SiteMode />
      </div>
      <div
        className={cn(styles.countDownAd, styles.topBar, {
          [styles.blackFriday]: blackFridayIsActive
        })}
      >
        {countDownAd && <CountdownAd {...countDownAd} />}
      </div>
    </>
  );
};
